<template>
  <transition name="fade">
    <div class="popup tips-popup" v-if="popupState.welcome">
      <div class="popup-mask fade-in" @click="closeWelcomePopup"></div>
      <div class="popup-welcome" @click="clickWelcomePopup">
        <a
          href="javascript:void(0);"
          class="popup-welcome-close"
          @click.stop="closeWelcomePopup"
        ></a>
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import popupHook from "@/hooks/popupHook";
import { getParam } from "@/utils/index";
const { popupState, clickWelcomePopup, closeWelcomePopup, showWelcomePopup } =
  popupHook();
import menuHook from '@/hooks/menuHook';
const { isStore, handleIpLocation } = menuHook();
onMounted(async () => {
  await handleIpLocation();
  // 如果store==1显示欢迎弹窗
  if (isStore.value) {
    showWelcomePopup();
  }
});
</script>
